import { ApplicationState } from '../../store'

export const getActiveUserHkId = (state: ApplicationState): string =>
  state.users.activeUserHkId || 'unknown'
